/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumItem1
 */
export interface EnumItem1 {
    /**
     * 编码
     * @type {number}
     * @memberof EnumItem1
     */
    code?: number;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof EnumItem1
     */
    name?: string;
}

/**
 * Check if a given object implements the EnumItem1 interface.
 */
export function instanceOfEnumItem1(value: object): value is EnumItem1 {
    return true;
}

export function EnumItem1FromJSON(json: any): EnumItem1 {
    return EnumItem1FromJSONTyped(json, false);
}

export function EnumItem1FromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumItem1 {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EnumItem1ToJSON(json: any): EnumItem1 {
    return EnumItem1ToJSONTyped(json, false);
}

export function EnumItem1ToJSONTyped(value?: EnumItem1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

